import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useVerifyOtpSchema = () => {
  const { t } = useTranslation("auth");

  const schema = useMemo(
    () =>
      z.object({
        otp: z.string().min(6, t("verifyOtp.otpRequired"))
      }),
    [t]
  );

  return schema;
};

export type VerifyOtpSchema = z.infer<ReturnType<typeof useVerifyOtpSchema>>;
